(function (scope) {
  'use strict';
  if (typeof HTMLElement === 'undefined' || !scope.customElements) return;

  const contexts = {
    all: '',
    family: '家族で過ごす家の、水・食事・トイレなどを選ぶ入口です。',
    child: '子どもの年齢や、普段の食事・生活に合うかを確かめて選びましょう。',
    pet: 'ペットの体格や普段の生活、避難先の受け入れ条件に合うかを確かめて選びましょう。'
  };

  class SonamaruSelection extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.onClick = (event) => {
        const button = event.target.closest('[data-sm-audience]');
        if (button && this.contains(button)) this.select(button.dataset.smAudience);
      };
      this.onPathway = (event) => {
        const link = event.target.closest('[data-sm-audience-link]');
        if (link) this.select(link.dataset.smAudienceLink);
      };
      this.addEventListener('click', this.onClick);
      document.addEventListener('click', this.onPathway);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      document.removeEventListener('click', this.onPathway);
      this.ready = false;
    }

    select(audience) {
      if (!Object.prototype.hasOwnProperty.call(contexts, audience)) return;
      const context = this.querySelector('[data-sm-selection-context]');
      if (!context) return;
      for (const button of this.querySelectorAll('[data-sm-audience]')) {
        button.setAttribute('aria-pressed', String(button.dataset.smAudience === audience));
      }
      context.textContent = contexts[audience];
      const products = this.querySelectorAll('[data-sm-product-audiences]');
      let visibleCount = 0;
      for (const product of products) {
        const audiences = product.dataset.smProductAudiences.split(/\s+/).filter(Boolean);
        product.hidden = audience !== 'all' && !audiences.includes(audience);
        if (!product.hidden) visibleCount += 1;
      }
      const emptyState = this.querySelector('[data-sm-selection-no-match]');
      if (emptyState) emptyState.hidden = visibleCount > 0;
    }
  }

  if (!scope.customElements.get('sonamaru-selection')) scope.customElements.define('sonamaru-selection', SonamaruSelection);
})(typeof globalThis !== 'undefined' ? globalThis : window);
